import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../styles/bitacora.css';
import '../../styles/sales.css';
import '../../styles/saleStatusBadges.css';
import SaleDetailModal from '../../components/Sales/SaleDetailModal';
import { TableCard } from '../../components/ui';
import { useSalesList } from './useSalesList';
import SalesListFiltersCard from './SalesListFiltersCard';
import SalesListTable from './SalesListTable';

/**
 * Sales list for branch sellers (vendedor / ROLE_COMMERCIAL).
 * Scope is enforced by the API; UI columns are seller-specific.
 */
const SellerSalesPage = () => {
  const {
    sales,
    loading,
    selectedSale,
    showDetailModal,
    setShowDetailModal,
    setSelectedSale,
    exporting,
    pagination,
    filters,
    approvalStatusOptions,
    settlementStatusOptions,
    handleFilterChange,
    handleApplyFilters,
    handleClearFilters,
    handleViewDetail,
    handleGoToCustomer,
    handleExportExcel,
    Pagination,
  } = useSalesList();

  return (
    <div className="page-content sales-page">
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3>Listado de Ventas</h3>
            <p className="text-subtitle text-muted">Listado de ventas realizadas por el comercio.</p>
          </div>
        </div>
      </div>

      <section className="section">
        <TableCard
          toolbar={(
            <SalesListFiltersCard
              filters={filters}
              approvalStatusOptions={approvalStatusOptions}
              settlementStatusOptions={settlementStatusOptions}
              loading={loading}
              exporting={exporting}
              onFilterChange={handleFilterChange}
              onApplyFilters={handleApplyFilters}
              onClearFilters={handleClearFilters}
              onExportExcel={handleExportExcel}
            />
          )}
          table={(
            <SalesListTable
              sales={sales}
              loading={loading}
              pagination={pagination}
              onViewDetail={handleViewDetail}
              onGoToCustomer={handleGoToCustomer}
            />
          )}
          pagination={<Pagination loading={loading} />}
        />

        {showDetailModal && (
          <SaleDetailModal
            saleId={selectedSale.id}
            customerId={selectedSale.customer.id}
            onClose={() => {
              setShowDetailModal(false);
              setSelectedSale(null);
            }}
          />
        )}
      </section>
    </div>
  );
};

export default SellerSalesPage;
